<div class="flex flex-col w-full gap-4">
    <div *ngFor="let item of items"
        class="w-full bg-white rounded-lg overflow-hidden border-b border-gray-300 flex items-center p-4 justify-between">

        <div class="w-24 h-24 ">
            <img *ngIf="!item.imageUrl!.includes('item-default.jpg')" [src]="item.imageUrl" [alt]="item.name" class="w-full h-full object-cover rounded-lg">
            <app-default-image *ngIf="item.imageUrl!.includes('item-default.jpg')" [element]="'imageListH'"></app-default-image>
        </div>

        <div class="flex flex-col pl-4  w-1/3">
            <p class="text-sm text-gray-500">{{ item.category }}</p>
            <h3 class="text-lg font-semibold text-[var(--p-info-500)] ">
                <span [innerHTML]="item.name | sanitizeHtmlText"></span>
                <fa-icon [icon]="item.isFavorite ? faBookmarkSolid : faBookmarkRegular"
                    class="text-[var(--p-info-500)] text-base cursor-pointer ml-4 align-middle" (click)="toggleFavorite(item)">
                </fa-icon>
            </h3>
            <p class="text-gray-300 text-sm">Item Number: {{item.lotNumber}}</p>
        </div>

        <div class="flex-1 flex flex-col justify-center  text-center  w-1/3">

            @if (item.isBiddable || item.isBuyable) {
            <p class="mt-1">
                <span class="text-lg font-bold text-custom-black">
                    {{ item.isBiddable ? item.currentLeadingBid : item.buyNowPrice }}
                </span>
                <span class="text-[var(--p-primary-500)] text-sm font-semibold ml-2">
                    {{ item.isBiddable ? (item.numberOfBids === 0 ? 'Opening Bid' : 'Leading Bid') : 'Buy Now' }}
                </span>
            </p>
            }

            <p>
                <span *ngIf="item.estimatedValue; else noEstimatedValue" class="text-[#6E6E6E] text-sm">
                    {{ isAmountEstimatedValue(item.estimatedValue) ? item.estimatedValue + ' Estimated Value' :
                    'Priceless' }}
                </span>
                <ng-template #noEstimatedValue>
                    <span class="text-gray-500 text-xs invisible">-</span>
                </ng-template>
            </p>
        </div>
        <div class="flex flex-col items-center w-80">
            <button pButton
                class="!bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] rounded-lg w-full px-2 py-4 font-semibold shadow-xs flex items-center justify-center"
                [rounded]="true" (click)="onOpenModalHorizontal(item.id!)">
                <span class="pi pi-credit-card !text-[var(--p-text-color-secondary)]"></span>
                <span class="!text-[var(--p-text-color-secondary)] font-mulish text-xs md:text-sm font-semibold whitespace-nowrap">
                    @if (item.isBiddable) {
                    <span>Place a Bid</span>
                    } @else if (item.isBuyable) {
                    <span>Buy Now</span>
                    } @else {
                    <span>See More</span>
                    }
                </span>
            </button>
            <div class="text-center mt-2">
                <p class="h-5 text-black font-mulish font-medium text-sm italic">
                    {{ timeLeftService.getTimeLeft(item.openingDate, item.closingDate) }}

                </p>
            </div>
        </div>
    </div>
</div>